var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6848 20.1653L18.6849 14.1652L15.835 11.3152L9.83484 17.3154C9.75224 17.3981 9.69356 17.5016 9.66503 17.6149L9 21.0002L12.3846 20.3351C12.4982 20.3067 12.6021 20.248 12.6848 20.1653ZM20.6219 12.2282C20.864 11.986 21 11.6576 21 11.3152C21 10.9728 20.864 10.6444 20.6219 10.4023L19.5979 9.37823C19.3557 9.13615 19.0273 9.00015 18.6849 9.00015C18.3425 9.00015 18.0141 9.13615 17.772 9.37823L16.7479 10.4023L19.5979 13.2522L20.6219 12.2282Z",
    fill: "#636467"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500153,
    width: 29,
    height: 29,
    rx: 4.5,
    stroke: "#DCDCF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.27b86a32.svg";
export { ForwardRef as ReactComponent };